var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import styles from './PageTitle.module.scss';
var PageTitle = /** @class */ (function (_super) {
    __extends(PageTitle, _super);
    function PageTitle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PageTitle.prototype.render = function () {
        var title = this.props.title;
        return (React.createElement("div", { className: styles.wrapper },
            React.createElement("div", { className: styles.title }, title)));
    };
    return PageTitle;
}(React.PureComponent));
export { PageTitle };
